<template>
  <div class="position-relative mb-1">
    <div class="input-sizer">
      <span :class="['spacer', 'form-control', {'all-emoji': isJustEmoji}]" contenteditable="true"><br>{{ value }}</span>
      <textarea
        ref="textarea"
        name="Message"
        aria-label="Message"
        :value="value"
        cols="30"
        :class="['form-control', {'all-emoji': isJustEmoji}]"
        :disabled="disabled"
        @input="updateValue($event.target.value)"
        @keyup="updateTrigger"
      />
    </div>
    <div v-if="!disabled" class="button-group border rounded-pill">
      <CannedResponsePicker
        v-if="cannedResponses"
        :canned-responses="cannedResponses"
        :textarea="box"
        :trigger="trigger"
        @input="updateValue"
        @cancelTrigger="cancelTrigger"
      />
      <InputButton
        v-if="showImageUploadInvoker"
        class="image-upload-invoker"
        icon="image"
        label="Upload image"
        @click="() => uploaderOpen = !uploaderOpen"
      />
      <EmojiPicker
        :textarea="box"
        @input="updateValue"
        @cancelTrigger="cancelTrigger"
      />
    </div>
    <UploaderWrapper
      v-if="tokenUrl"
      :attach-image="attachImage"
      :on-close="() => uploaderOpen = false"
      :is-open="uploaderOpen"
      :token-url="tokenUrl"
    />
  </div>
</template>
<script>
import EmojiPicker from '@/FormWidgets/WidgetInputArea/components/EmojiPicker.vue'
import {isJustEmoji} from '@/Inbox/helpers/emojiHelper'
import InputButton from "@/FormWidgets/WidgetInputArea/components/InputButton.vue";
import CannedResponsePicker from "@/FormWidgets/WidgetInputArea/components/CannedResponsePicker.vue";
import UploaderWrapper from "@/FormWidgets/WidgetInputArea/components/UploaderWrapper.vue";

export default {
  name: 'InputArea',
  // Vue 3:
  // emits: ['input', 'openImageUpload'],
  components: {
    UploaderWrapper,
    CannedResponsePicker,
    InputButton,
    EmojiPicker,
  },
  props: {
    cannedResponses: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true
    },
    // todo: If we have the image URL as a prop, this component could display the name of the file and do attachImage itself
    // showImageUploadInvoker can become a calculated prop
    // And a watcher could clear the name when the URL is set to null
    showImageUploadInvoker: {
      type: Boolean,
      default: false,
    },
    attachImage: {
      type: Function,
      default: () => {},
    },
    tokenUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isJustEmoji: false,
      trigger: null, // must not be under provide/inject to be reactive
      uploaderOpen: false,
      height: 100,
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.changeTextareaFontSize(newVal);
      },
      immediate: true
    },
  },
  methods: {
    box() {
      return this.$refs.textarea;
    },
    updateValue(text) {
      this.$emit('input', text);
    },
    cancelTrigger(refocus) {
      this.updateTrigger(false);
      if(refocus) {
        this.$refs.textarea.focus();
      }
    },
    updateTrigger(event) {
      this.trigger = event;
    },
    changeTextareaFontSize(newVal) {
      this.isJustEmoji = isJustEmoji(newVal);
    },
  },
}
</script>

<style scoped>

.input-sizer {
  position: relative;
  width: 100%;

  /* Use a textarea for input, but hide a span (.spacer) behind it with the same content to take up the appropriate space on
     the page, thus giving the impression that the textarea is being resized to its own content (not really possible portably) */
  .spacer,
  textarea {
    /* Approximately 3 buttons plus their padding: */
    min-height: calc(1.5 * 3rem + 2 * 0.75rem);
    width: 100%;
    /* Approximately 1 button plus its padding: */
    padding-right: 2rem;
    height: 100%;
    max-width: 100%;
    resize: none;
    white-space: pre-wrap;
  }
  .spacer {
    margin-top: 1em;
    visibility: hidden;
  }
  textarea{
    top: 0;
    position: absolute;
  }
}

/* Set by methods.changeTextareaFontSize */
.all-emoji {
  font-size: 1.8rem;
}

.button-group {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  display: flex;
  /* Minimize right padding needed to keep text off buttons: */
  flex-direction: column;
}

</style>